<template>
  <ResourceErrorState kind="unavailable" @retry="retry" />
</template>

<script setup lang="ts">
import { useRoute, useRouter } from "vue-router";
import ResourceErrorState from "@/components/layout/ResourceErrorState.vue";

/**
 * Shown when the router guard cannot even establish who the user is — the backend is down or
 * erroring. The only route-level error page: every other failure happens inside a view that is
 * already on screen, and is rendered there so the URL survives.
 *
 * The page the user was heading for rides along in the query, so retrying resumes it instead of
 * dumping them on the dashboard.
 */
const route = useRoute();
const router = useRouter();

const retry = () => {
  const target = route.query.redirect;
  router.replace(
    typeof target === "string" && target.startsWith("/") ? target : "/"
  );
};
</script>
